// removed by extract-text-webpack-plugin
module.exports = {"root":"Panel__root___34eHt","noOverflow":"Panel__noOverflow___3NP0d","background":"Panel__background___3A5VK"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Panel/Panel.css
// module id = 100
// module chunks = 0